module.exports = __webpack_public_path__ + "fonts/HeiseiKakuGoStd-W3.95cda9ea.otf";